import React, { useState, useEffect, lazy } from "react";
import Values from "../components/commons/values/";
import CustomerTestimonials from "../components/commons/testimonials/customer_testimonials.js";
import Empowerment from "../components/home/empowerment/";
import NewsLetterPopUp from "../modals/newsLetterModal";
import useLocalStorage from "../effects/LocalStorage/use-local-storage";
import _ from "lodash";
const Header = lazy(() => import("../components/commons/header"));
const Banner = lazy(() => import("../components/home/banner/"));
const Footer = lazy(() => import("../components/commons/footer"));

const HomeLayout = ({ children, ...rest }) => {
  const [newsLetterPopUp, setconfirmationModal] = useState(false);
  const toggleConfirmationModal = () => setconfirmationModal(!newsLetterPopUp);
  
  const [userDetails] = useLocalStorage("userDetails", {});
  useEffect(() => {
    if (_.isEmpty(userDetails)) {
      setconfirmationModal(true);
    }
  }, []);

  return (
    <div className="App">
      <Header />
      <Banner />
      {/*
        <Empowerment />
        <Values />
           */}
      {/* <CustomerTestimonials /> */}
      <Footer />
      {/*
            <NewsLetterPopUp toggle={toggleConfirmationModal} isOpen={newsLetterPopUp} />
            */}
    </div>
  );
};

export default HomeLayout;
